import { ArrowCaret } from '@fs/zion-icon/dist/cjs/icons'
import { css } from '@emotion/core'
import { IconButton, Row } from '@fs/zion-ui'
import React from 'react'

const pageIndicator = css`
  display: flex;
  border: 1px solid var(--gray100);
  width: 36px;
  height: 36px;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
`

export default function PreviousNext({ direction, page, onPrevious, onNext, disablePrevious, disableNext }) {
  return (
    <>
      {direction === 'vertical' ? (
        <div id="vertical-previous-next" style={{ display: 'flex', flexDirection: 'column' }}>
          <IconButton
            Icon={ArrowCaret}
            iconDirection="up"
            onClick={onPrevious}
            disabled={disablePrevious}
            data-testid="vertical previous"
          />
          <IconButton
            Icon={ArrowCaret}
            iconDirection="down"
            onClick={onNext}
            disabled={disableNext}
            data-testid="vertical next"
          />
        </div>
      ) : (
        <Row id="horizontal-previous-next" gutters="nano" alignY="middle">
          <IconButton
            Icon={ArrowCaret}
            iconDirection="backward"
            onClick={onPrevious}
            disabled={disablePrevious}
            data-testid="horizontal previous"
          />
          <span css={pageIndicator}>{page}</span>
          <IconButton
            Icon={ArrowCaret}
            iconDirection="forward"
            onClick={onNext}
            disabled={disableNext}
            data-testid="horizontal next"
          />
        </Row>
      )}
    </>
  )
}
